import {useMutation} from '@tanstack/react-query';
import createG2ReviewSession from '@/api/updaters/g2ReviewSession';

export default function useCreateG2ReviewSession() {
  return useMutation({
    mutationFn: createG2ReviewSession,
  });
}
